// extracted by mini-css-extract-plugin
export default {"l_text_area_main":"Textarea_l_text_area_main__0d68A","disabled":"Textarea_disabled__uKIBl"};